import React, { useContext, useEffect, useState } from 'react'
import { Accordion, AccordionItem } from '@szhsin/react-accordion';
import useSocket from '../../Websoket.js';
import './matchdata.css'
import { PopupContext } from '../LoginPopup/LoginPopupContext.js';
import betslipclosearrow from '../../assets/images/betslip-close-arrow.png'
import ExchanngeinfoPopup from './ExchanngeinfoPopup.js';
import SubNotification from '../common/SubNotification.jsx';
import config from '../../config.js';
import { SocketContext } from '../../SocketContext.js';

function MatchOdds({ eventAccess, getMatchOdds, onBetClick,getUnderOver,myNotification }) {
    const matchOdds = {
        "eventId": eventAccess?.matchData?.eventId,
        "marketIds": [
            eventAccess?.matchoddId
        ]
    };
    const items = Array(4).fill(null);
    // console.log(getUnderOver, 'MMMMMMMMMMMMMMMMMMMMMMMMMMMMM');

    const [ismultimarket, setIsmultimarket] = useState(false)
    const [multimarketArray, setMultimarketArray] = useState([])
    const isOneClicked = sessionStorage.getItem('isOneClicked')
    let oneClickValue
    if(isOneClicked == 'true'){
        oneClickValue = sessionStorage.getItem('oneClickAmount')
    }
    const [firstTimeCall, setFirstTimeCall] = useState(false)

    const [odds, setOdds] = useState(matchOdds);
    const [slideToggle, setSlideToggle] = useState(false)
    const { isConnected, receivedMatchodds,receivedunderOve0,receivedunderOve1,receivedunderOve2,receivedunderOve3,receivedBookData,receivedunderOvebook, sendMessage, receivedcashoutMO,clearCashout } = useContext(SocketContext);
    const [priceGet, setPriceGet] = useState();
    const [plusMinusValue, setplusMinusValue] = useState();
    const [bklyClassValue, setBklyClass] = useState();
    const [oddsValue, setoddsValue] = useState();
    const [eventObj, setEventObj] = useState(null); // State to store event
    const [oldOddsValue, setOldOddsValue] = useState();
    const [isLoggedIn, setIsLoggedIn] = useState(!!sessionStorage.getItem('loggedIn'));
    const { openPopup, loggedIn, isLoggedOut, direactsecId, setSecIds,clearSecId,unsetBetLoader,isBetUpdate,betNotUpdated,isBetLoader, loaderCounter,stackArray} = useContext(PopupContext);
    const [disable, setDisable] = useState(false);
    const [stack, setStack] = useState([]);
    const max_odd = receivedMatchodds?.finalResult?.[0]?.max_odd
    const [checkBet, setCheckBet] = useState();
    const [grulesPopup, setGrulesPopup] = useState();
    const [Beton, setBeton] = useState();
    const [perticularprofit, setperticularprofit] = useState();

    const escapeSelectorId = (id) => {
        if(id){
            return String(id).replace(/([#.,+*~':"!^$[\]()=>|\\/])/g, '\\$1');
        }
    };

    const gruleshandleClose = ()=>{
        setGrulesPopup(false);
    }
    const grulesHandle = ()=>{
        setGrulesPopup(true);
    }

    const getSelectedReceivedUnderOve = (k) => {
        switch (k) {
          case 0:
            return receivedunderOve0;
          case 1:
            return receivedunderOve1;
          case 2:
            return receivedunderOve2;
          case 3:
            return receivedunderOve3;
          default:
            return null; // Handle invalid `k`
        }
      };

      const getSubNotification = (ids) => {
        // let data = JSON.stringify({
        //     "marketIds":ids
        // })
        // const myHeaders = new Headers();
        // myHeaders.append("Content-Type", "application/json");
    
        // const requestOptions = {
        //   method: "POST",
        //   headers: myHeaders,
        //   redirect: "follow",
        //   body: data,
        // };
    
        // fetch(`${process.env.REACT_APP_BASE_URL}/api/v1/notification/getmarketNotitfication`, requestOptions)
        //   .then(async (response) => {
        //     let paresData = await response.json();
        //     setMyNotification(paresData?.notifications);
        //     console.log("getmarketNotitfication - ", paresData?.notifications);
        //   })
        //   .catch((error) => {
        //     console.log(error);
        //   });
        // https://devapi.maruti.dev/
      }

    useEffect(() => {
        // Call cashOuthandle3 when receivedMatchodds updates and is valid
        if (Object.keys(receivedcashoutMO).length > 0 && receivedcashoutMO.secId) {
            cashOuthandle3();
        }
        // console.log(multimarketArray,"-------multimarketArray");
    }, [receivedcashoutMO,receivedMatchodds,getUnderOver,multimarketArray]); // Dependency array: this runs whenever receivedMatchodds changes

    // console.log(receivedunderOve0, eventAccess, 'eventAccess');

    const toggleHandle2 = (secId, bklyClass, odds, Stake) => {
        // console.log(secId,"------15151515");

        setSlideToggle(slideToggle === secId ? secId : secId);
        setBklyClass(bklyClass);
        setoddsValue(odds);
        setPriceGet(Stake);
        setSecIds(secId)
    };

    const cashOuthandle3 = () => {
        let type = receivedcashoutMO.betType === "LAY" ? 'lay' : 'back';
        toggleHandle2(receivedcashoutMO.secId, type, receivedcashoutMO.odds, receivedcashoutMO.stake.toFixed(2));
    };

    const handleCashOut = () => {
        let marketId = receivedMatchodds?.finalResult?.[0]?.marketId;
        let userinfo = sessionStorage.getItem('userinfo');
        let eventID = eventAccess?.matchData?.eventId;
        setSlideToggle(false)
        if (userinfo && eventID) {
            userinfo = JSON.parse(userinfo);
            sendMessage('cashOOut', { id: marketId, user: userinfo, eventID });
        }else{
        // console.log(userinfo,eventID,'222222222222');

        }
    };

    const addAllValue =   (newValue,event) => {
        if(priceGet != newValue){
        handleSendMarketBookDetails();
        setTimeout(() => {
                const closestBetslip = event.target.closest('.data-with-betslip');
                if (closestBetslip) {
                    const bookValueDiv = closestBetslip.querySelector('.book-value');
                    if (bookValueDiv) {
                        // console.log('Found book-value:', bookValueDiv);
                        let value
                        if(bookValueDiv.innerText == ''){
                            if(bklyClassValue === 'back'){
                                value = (newValue * oddsValue) - (newValue)
                            }else{
                                value = -((newValue * oddsValue)- (newValue))
                            }
                        }else{
                            let previousValue = bookValueDiv.innerText
                            if(bklyClassValue === 'back'){
                                value = parseFloat((newValue * oddsValue) - newValue) + parseFloat(previousValue)
                            }else{
                                value = parseFloat(previousValue) - parseFloat((newValue * oddsValue)- newValue)
                            }
                        }
                        bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
            ? Number(value).toFixed(2)
            : 'Invalid value';
                        setperticularprofit(value)
                        if(value > 0){
                            bookValueDiv.classList.remove('red-txt')
                            bookValueDiv.classList.add('green-txt')
                        }else{
                            bookValueDiv.classList.remove('green-txt')
                            bookValueDiv.classList.add('red-txt')
                        }
                        const closestBetslip2 = event.target.closest('.match-list');
                        const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');
                        // console.log(allBookValueDivs, closestBetslip2);
        
                        allBookValueDivs.forEach(div => {
                            if (div !== bookValueDiv) {
                                let value
                                if(div.innerText == ''){
                                    if(bklyClassValue === 'back'){
                                        value = -newValue
                                    }else{
                                        value = newValue
                                    }
                                }else{
                                    let previousValue = div.innerText
                                    if(bklyClassValue === 'back'){
                                        value = previousValue - newValue
                                    }else{
                                        value = parseFloat(newValue) + parseFloat(previousValue)
                                    }
                                }
                                div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
            ? Number(value).toFixed(2)
            : 'Invalid value';
                                if(value > 0){
                                    div.classList.remove('red-txt')
                                    div.classList.add('green-txt')
                                }else{
                                    div.classList.remove('green-txt')
                                    div.classList.add('red-txt')
                                }
        
                            }
                        });
                    } else {
                        console.log('.book-value div not found');
                    }
                } else {
                    console.log('.data-with-betslip not found');
                }
            }, 300);
            }

        setplusMinusValue(newValue)
        setPriceGet(newValue);

    };

    const addValue = (newValue,event) => {
        const closestBetslip = event.target.closest('.data-with-betslip');
        if (closestBetslip) {
            const bookValueDiv = closestBetslip.querySelector('.book-value');
            if (bookValueDiv) {
                let value
                if(bookValueDiv.innerText == ''){
                    if(bklyClassValue === 'back'){
                        value = (newValue * oddsValue) - newValue
                    }else{
                        value = -((newValue * oddsValue) - newValue)
                    }
                }else{
                    let previousValue = bookValueDiv.innerText
                    if(bklyClassValue === 'back'){
                        value = parseFloat((newValue * oddsValue) - newValue) + parseFloat(previousValue)
                    }else{
                        value = previousValue - parseFloat((newValue * oddsValue) - newValue)
                    }
                }
                bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                setperticularprofit(value)
                if(value > 0){
                    bookValueDiv.classList.remove('red-txt')
                    bookValueDiv.classList.add('green-txt')
                }else{
                    bookValueDiv.classList.remove('green-txt')
                    bookValueDiv.classList.add('red-txt')
                }
                const closestBetslip2 = event.target.closest('.match-list');
                const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');

                allBookValueDivs.forEach(div => {
                    if (div !== bookValueDiv) {
                        let value
                        if(div.innerText == ''){
                            if(bklyClassValue === 'back'){
                                value = -newValue
                            }else{
                                value = newValue
                            }
                        }else{
                            let previousValue = div.innerText
                            if(bklyClassValue === 'back'){
                                value = previousValue - newValue
                            }else{
                                value =   parseFloat(previousValue) + parseFloat(newValue)
                            }
                        }
                        div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                        if(value > 0){
                            div.classList.remove('red-txt')
                            div.classList.add('green-txt')
                        }else{
                            div.classList.remove('green-txt')
                            div.classList.add('red-txt')
                        }

                    }
                });
            } else {
                console.log('.book-value div not found');
            }
        } else {
            console.log('.data-with-betslip not found');
        }



        setplusMinusValue(newValue)
        if (priceGet !== undefined) {
            setPriceGet(prevPrice => Number(prevPrice) + Number(newValue));
        } else {
            setPriceGet(newValue);
        }

    };

    const handleSendMarketBookDetails = () => {
        // console.log('ttttttttttttttttttttttttttttttttttttttttttttttttttttt');

        let eventId =  eventAccess?.matchData?.eventId;
        let marketId = eventAccess?.matchoddId;
        let userinfo = sessionStorage.getItem('userinfo');
        if (userinfo && eventId && marketId) {

            userinfo = JSON.parse(userinfo);
            sendMessage('marketIdbookDetails', { eventId, marketId, user: userinfo });
            if(eventAccess?.matchData?.sportId == '1'){
                sendMessage('marketIdbookDetailsUnderOver', { eventId, user: userinfo });
            }
        } else if(!userinfo){
            sendMessage('marketIdbookDetails', { eventId, marketId });
            if(eventAccess?.matchData?.sportId == '1'){
                sendMessage('marketIdbookDetailsUnderOver', { eventId, user: userinfo });
            }
        }else{
            console.error('Missing eventId or marketId');
        }
    };

    useEffect(() => {
        setPreviousBookValues();
    }, [receivedBookData]);

    const setPreviousBookValues = () => {
        if (receivedBookData && receivedBookData.showData) {
            for (let i = 0; i < receivedBookData.showData.length; i++) {
                const originalId = receivedBookData.showData[i].runnerId;
                const escapedId = escapeSelectorId(originalId);
                const element = document.getElementById(`${escapedId}`);
                if (element) {
                    const mainDiv = element.querySelector('.book-value');
                    if (mainDiv) {
                        mainDiv.innerText = receivedBookData.showData[i].amount !== null && receivedBookData.showData[i].amount !== undefined &&  !isNaN(Number(receivedBookData.showData[i].amount)) ? Number(receivedBookData.showData[i].amount).toFixed(2) : 'Invalid data';
                        if (receivedBookData.showData[i].amount > 0) {
                            mainDiv.classList.remove('red-txt');
                            mainDiv.classList.add('green-txt');
                        } else {
                            mainDiv.classList.remove('green-txt');
                            mainDiv.classList.add('red-txt');
                        }
                    } else {
                        console.error(`.book-value not found for ID: #${escapedId}`);
                    }
                } else {
                    console.error(`Element with ID #${escapedId} not found. Original ID was: ${originalId}`);
                }
            }
            if (receivedBookData.showData.length == 0) {

                // Use the ID directly with getElementById
                let element = document.getElementById(receivedBookData.marketId);

                if (!element) {
                    // If element is still null, escape special characters for querySelector
                    const escapedId = receivedBookData.marketId.replace(/([.#$[\]])/g, '\\$1');

                    // Use querySelector with escaped ID
                    element = document.getElementById(`${escapedId}`);
                }


                if (element) {
                    let divs = element.querySelectorAll('.book-value');

                    divs.forEach(div => {
                        div.innerText = '';  // Clear the text inside each .book-value div
                    });
                } else {
                }
            }
        }
        if (receivedunderOvebook && receivedunderOvebook.showData) {
            for (let i = 0; i < receivedunderOvebook.showData.length; i++) {
                const originalId = receivedunderOvebook.showData[i].runnerId;
                const escapedId = escapeSelectorId(originalId);
                const element = document.getElementById(`${escapedId}`);
                if (element) {
                    const mainDiv = element.querySelector('.book-value');
                    if (mainDiv) {
                        mainDiv.innerText = receivedunderOvebook.showData[i].amount !== null && receivedunderOvebook.showData[i].amount !== undefined &&  !isNaN(Number(receivedunderOvebook.showData[i].amount)) ? Number(receivedunderOvebook.showData[i].amount).toFixed(2) : 'Invalid data';
                        if (receivedunderOvebook.showData[i].amount > 0) {
                            mainDiv.classList.remove('red-txt');
                            mainDiv.classList.add('green-txt');
                        } else {
                            mainDiv.classList.remove('green-txt');
                            mainDiv.classList.add('red-txt');
                        }
                    } else {
                        console.error(`.book-value not found for ID: #${escapedId}`);
                    }
                } else {
                    console.error(`Element with ID #${escapedId} not found. Original ID was: ${originalId}`);
                }
            }
            if (receivedunderOvebook.showData.length == 0) {

                let elements = document.querySelectorAll('.under-over');

                elements.forEach(element => {
                    let divs = element.querySelectorAll('.book-value');

                    divs.forEach(div => {
                        div.innerText = '';
                    });
                })
            }else{
                let elements = document.querySelectorAll('.under-over');
                // console.log(receivedunderOvebook);

                elements.forEach(element => {
                    if(receivedunderOvebook.showData[0]){
                        if(!receivedunderOvebook.showData.some(item => item.marketId == element.id)){
                            let divs = element.querySelectorAll('.book-value');

                            divs.forEach(div => {
                                div.innerText = '';
                            });
                        }
                    }else{
                        let divs = element.querySelectorAll('.book-value');

                        divs.forEach(div => {
                            div.innerText = '';
                        });
                    }
                })

            }
        }
    };

    const getBetSlipClasss = (oddItem) => {
        if (direactsecId === oddItem.runnerId) {
            if(oddItem.status !== 'ACTIVE'){
                clearSecId()
                unsetBetLoader();
                return 'betslip-wraper'
            }else{
                return 'betslip-wraper open'
            }
        }
        return 'betslip-wraper';
      };

    useEffect(() => {
        // console.log(stackArray, Array.isArray(JSON.parse(stackArray)),"----------stackArray12313");
        try{
            setStack(JSON.parse(stackArray));
            if(!isBetLoader){
                handlecloseSlip();
            }
        }catch(err){
            console.log(err, 'errerrerrerr');
            setStack(stackArray)
            if(!isBetLoader){
                handlecloseSlip();
            }
        }
    }, [isBetLoader, loaderCounter,stackArray]);

    useEffect(() => {
        if (direactsecId !== '') {
          setPreviousBookValues();
        }
    }, [direactsecId]);

    useEffect(() => {
        if (oddsValue !== null && eventObj !== null) {
          updateOddsBook(eventObj)
        }
    }, [oddsValue]);

    const updateOddsBook = (event) => {
        const closestBetslip = event.target.closest('.data-with-betslip');
        if (closestBetslip) {
            const bookValueDiv = closestBetslip.querySelector('.book-value');
            if (bookValueDiv) {
                if(priceGet){
                    let value
                if(bookValueDiv.innerText === ''){
                    if(bklyClassValue === 'back'){
                        value = (priceGet * oddsValue) - priceGet
                    }else{
                        value = -((priceGet * oddsValue) - priceGet)
                    }
                }else{
                    let previousValue = bookValueDiv.innerText
                    // console.log(oldOddsValue,  );

                    if(bklyClassValue === 'back'){
                        let oldValue = parseFloat((priceGet * oldOddsValue)- priceGet)
                        let newValue = parseFloat((priceGet * oddsValue)- priceGet)
                        value = parseFloat(previousValue) + newValue - oldValue
                    }else{
                        let oldValue = -parseFloat((priceGet * oldOddsValue)- priceGet)
                        let newValue = -parseFloat((priceGet * oddsValue)- priceGet)
                        value =  parseFloat(previousValue) - oldValue + newValue

                    }
                }
                bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                setperticularprofit(value)
                if(value > 0){
                    bookValueDiv.classList.remove('red-txt')
                    bookValueDiv.classList.add('green-txt')
                }else{
                    bookValueDiv.classList.remove('green-txt')
                    bookValueDiv.classList.add('red-txt')
                }
                const closestBetslip2 = event.target.closest('.match-list');
                const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');
                allBookValueDivs.forEach(div => {
                    if (div !== bookValueDiv) {
                        let value
                        if(div.innerText == ''){
                            if(bklyClassValue === 'back'){
                                value = -priceGet
                            }else{
                                value = +priceGet
                            }
                            div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                        if(value > 0){
                            div.classList.remove('red-txt')
                            div.classList.add('green-txt')
                        }else{
                            div.classList.remove('green-txt')
                            div.classList.add('red-txt')
                        }
                        }else{
                            let previousValue = div.innerText
                            // if(bklyClassValue === 'back'){
                            //     value = previousValue - priceGet
                            // }else{
                            //     value =  parseFloat(priceGet) + parseFloat(previousValue)
                            // }
                        }


                    }
                });
                }else{
                    let diff = Math.abs(priceGet)

                    const closestBetslip = event.target.closest('.data-with-betslip');
                    if (closestBetslip) {
                        const bookValueDiv = closestBetslip.querySelector('.book-value');
                        if (bookValueDiv) {
                            let value
                            if(bookValueDiv.innerText == ''){
                                if(bklyClassValue === 'back'){
                                    value = (priceGet * oddsValue)- priceGet
                                }else{
                                    value = -((priceGet * oddsValue)- priceGet)
                                }
                            }else{
                                let previousValue = bookValueDiv.innerText
                                if(bklyClassValue === 'back'){
                                    value = parseFloat(previousValue) - parseFloat((diff * oddsValue)- diff)
                                }else{
                                    value = parseFloat(previousValue) + parseFloat((diff * oddsValue)- diff)
                                }
                            }
                            bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                            setperticularprofit(value)
                            if(value > 0){
                                bookValueDiv.classList.remove('red-txt')
                                bookValueDiv.classList.add('green-txt')
                            }else{
                                bookValueDiv.classList.remove('green-txt')
                                bookValueDiv.classList.add('red-txt')
                            }
                            const closestBetslip2 = event.target.closest('.match-list');
                            const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');
                            allBookValueDivs.forEach(div => {
                                if (div !== bookValueDiv) {
                                    let value
                                    if(div.innerText == ''){
                                        if(bklyClassValue === 'back'){
                                            value = -priceGet
                                        }else{
                                            value = priceGet
                                        }
                                    }else{
                                        let previousValue = div.innerText
                                        if(bklyClassValue === 'back'){
                                            value =  parseFloat(previousValue) + parseFloat(diff)
                                        }else{
                                            value =  parseFloat(previousValue) - parseFloat(diff)
                                        }
                                    }
                                    div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                                    if(value > 0){
                                        div.classList.remove('red-txt')
                                        div.classList.add('green-txt')
                                    }else{
                                        div.classList.remove('green-txt')
                                        div.classList.add('red-txt')
                                    }

                                }
                            });
                        }
                    }
                }
            }
        }
    }

    const updateBook = (event, oldvalue, newvalue) => {
        const closestBetslip = event.target.closest('.data-with-betslip');
        if (closestBetslip) {
            const bookValueDiv = closestBetslip.querySelector('.book-value');
            if (bookValueDiv) {
                if(oldvalue < newvalue){
                    newvalue = newvalue - oldvalue
                    let value
                if(bookValueDiv.innerText === ''){
                    if(bklyClassValue === 'back'){
                        value = (newvalue * oddsValue) - newvalue
                    }else{
                        value = -((newvalue * oddsValue) - newvalue)
                    }
                }else{
                    let previousValue = bookValueDiv.innerText
                    if(bklyClassValue === 'back'){
                        value = parseFloat((newvalue * oddsValue)- newvalue) + parseFloat(previousValue)
                    }else{
                        value = previousValue - parseFloat((newvalue * oddsValue)- newvalue)
                    }
                }
                bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                setperticularprofit(value)
                if(value > 0){
                    bookValueDiv.classList.remove('red-txt')
                    bookValueDiv.classList.add('green-txt')
                }else{
                    bookValueDiv.classList.remove('green-txt')
                    bookValueDiv.classList.add('red-txt')
                }
                const closestBetslip2 = event.target.closest('.match-list');
                const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');
                allBookValueDivs.forEach(div => {
                    if (div !== bookValueDiv) {
                        let value
                        if(div.innerText == ''){
                            if(bklyClassValue === 'back'){
                                value = -newvalue
                            }else{
                                value = +newvalue
                            }
                        }else{
                            let previousValue = div.innerText
                            if(bklyClassValue === 'back'){
                                value = previousValue - newvalue
                            }else{
                                value =  parseFloat(newvalue) + parseFloat(previousValue)
                            }
                        }
                        div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                        if(value > 0){
                            div.classList.remove('red-txt')
                            div.classList.add('green-txt')
                        }else{
                            div.classList.remove('green-txt')
                            div.classList.add('red-txt')
                        }

                    }
                });
                }else{
                    let diff = Math.abs(newvalue - oldvalue)

                    const closestBetslip = event.target.closest('.data-with-betslip');
                    if (closestBetslip) {
                        const bookValueDiv = closestBetslip.querySelector('.book-value');
                        if (bookValueDiv) {
                            let value
                            if(bookValueDiv.innerText == ''){
                                if(bklyClassValue === 'back'){
                                    value = (newvalue * oddsValue)- newvalue
                                }else{
                                    value = -((newvalue * oddsValue)- newvalue)
                                }
                            }else{
                                let previousValue = bookValueDiv.innerText
                                if(bklyClassValue === 'back'){
                                    value = parseFloat(previousValue) - parseFloat((diff * oddsValue)- diff)
                                }else{
                                    value = parseFloat(previousValue) + parseFloat((diff * oddsValue)- diff)
                                }
                            }
                            bookValueDiv.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                            setperticularprofit(value)
                            if(value > 0){
                                bookValueDiv.classList.remove('red-txt')
                                bookValueDiv.classList.add('green-txt')
                            }else{
                                bookValueDiv.classList.remove('green-txt')
                                bookValueDiv.classList.add('red-txt')
                            }
                            const closestBetslip2 = event.target.closest('.match-list');
                            const allBookValueDivs = closestBetslip2.querySelectorAll('.book-value');
                            allBookValueDivs.forEach(div => {
                                if (div !== bookValueDiv) {
                                    let value
                                    if(div.innerText == ''){
                                        if(bklyClassValue === 'back'){
                                            value = -newvalue
                                        }else{
                                            value = newvalue
                                        }
                                    }else{
                                        let previousValue = div.innerText
                                        if(bklyClassValue === 'back'){
                                            value =  parseFloat(previousValue) + parseFloat(diff)
                                        }else{
                                            value =  parseFloat(previousValue) - parseFloat(diff)
                                        }
                                    }
                                    div.innerText = value !== null && value !== undefined && !isNaN(Number(value))
    ? Number(value).toFixed(2)
    : 'Invalid value';
                                    if(value > 0){
                                        div.classList.remove('red-txt')
                                        div.classList.add('green-txt')
                                    }else{
                                        div.classList.remove('green-txt')
                                        div.classList.add('red-txt')
                                    }

                                }
                            });
                        }
                    }
                }
            }
        }
    }


    const PlusValue = (event) => {
        const newValue =  plusMinusValue ? plusMinusValue : 100
        let oldValue = priceGet
        if(oldValue.toString().trim() === ''){
            oldValue = 0
        }
        if (priceGet !== undefined) {
            setPriceGet(prevPrice => Number(prevPrice) + Number(newValue));
        } else {
            oldValue = 0
            setPriceGet(newValue);
        }
        let newValuestake =  parseFloat(oldValue) + parseFloat(newValue)

        updateBook(event, oldValue, newValuestake)
    };
    const subtractValue = (event) => {
        const valueToSubtract  =  plusMinusValue ? plusMinusValue : 100
        let oldValue = priceGet

        setPriceGet(prevPrice => {
            const currentPrice = prevPrice ? Number(prevPrice) : 0;
            const newPrice = currentPrice - valueToSubtract;
            return newPrice < 0 ? 0 : newPrice;
        });
        if(oldValue){
            let newValue = oldValue - valueToSubtract
            if(newValue > 0){

                updateBook(event, oldValue, newValue)
            }else{
                setPreviousBookValues()
            }
        }
    };

    const incrementValue = (increment, event) => {
        let oldValue = priceGet
        setPriceGet(prevPrice => {
            const currentPrice = prevPrice ? Number(prevPrice) : 0;
            return currentPrice + increment;
        });
        let newValue = parseFloat(oldValue + increment)
        if (newValue != 0) {
            updateBook(event, oldValue, newValue)
        }
        // updateBook(event, oldValue, newValue)
    };

    const removeLastDigit = (event) => {
        let oldValue = priceGet
        setPriceGet(prevPrice => {
            if (prevPrice !== undefined) {
                const newPrice = String(prevPrice).slice(0, -1);
                return newPrice === '' ? 0 : Number(newPrice);
            }
            return 0;
        });
        if(oldValue){
            let newValue = String(oldValue).slice(0, -1);
            if (newValue != 0) {
                updateBook(event, oldValue, newValue);
            }else{
                setPreviousBookValues()
            }
        }else{
            setPreviousBookValues()
        }
    };

    useEffect(() => {
        let intervalId;
        if (isConnected) {
            let matchdata = null;
            const userData = sessionStorage.getItem('userId');
    
            if (eventAccess?.matchoddId) {
                matchdata = {
                    eventId: eventAccess?.matchData?.eventId,
                    marketIds: [eventAccess?.matchoddId],
                    ...(userData && { userId: userData })
                };
            }
    
            if (!firstTimeCall) {
                setFirstTimeCall(true);
    
                if (eventAccess?.matchoddId && matchdata) {
                    sendMessage('matchOddsMarketIds', matchdata);
                }
    
                setMultimarketArray(eventAccess.multiMarketArray);
    
                for (let i = 0; i < items.length; i++) {
                    if (eventAccess?.[`overunder${i}Status`]) {
                        let datas = null;
                        const overunderId = eventAccess?.[`overunder${i}Id`];
                        if (userData) {
                            datas = {
                                eventId: eventAccess?.matchData?.eventId,
                                marketIds: [overunderId],
                                userId: userData
                            };
                        } else {
                            datas = {
                                userId: process.env.REACT_APP_ENV === 'development'
                                    ? '64db25fa1617ac95db367a0d'
                                    : '65fc48e7eab864a79776c01c',
                                eventId: eventAccess?.matchData?.eventId,
                                marketIds: [overunderId]
                            };
                        }
                        sendMessage(`overundermarketId${i}`, datas);
                    }
                }
            }
    
            intervalId = setInterval(() => {
                if (eventAccess?.matchoddId && matchdata) {
                    sendMessage('matchOddsMarketIds', matchdata);
                }
    
                for (let i = 0; i < items.length; i++) {
                    if (eventAccess?.[`overunder${i}Status`]) {
                        let datas = null;
                        const overunderId = eventAccess?.[`overunder${i}Id`];
                        if (userData) {
                            datas = {
                                eventId: eventAccess?.matchData?.eventId,
                                marketIds: [overunderId],
                                userId: userData
                            };
                        } else {
                            datas = {
                                userId: process.env.REACT_APP_ENV === 'development'
                                    ? '64db25fa1617ac95db367a0d'
                                    : '65fc48e7eab864a79776c01c',
                                eventId: eventAccess?.matchData?.eventId,
                                marketIds: [overunderId]
                            };
                        }
                        sendMessage(`overundermarketId${i}`, datas);
                    }
                }
            }, config.matchOddsMinMaxTime);
        }
    
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    
    }, [isConnected, odds, sendMessage]);
    


    const onClickFunction = (runnerId, toggleclass, event, runnerName,backPriceData) =>{
        event.persist();
        setSecIds(runnerId);
        setSlideToggle(slideToggle === runnerId ? runnerId : runnerId);
        setBklyClass(toggleclass);
        const strongElement = event.target.tagName === 'SPAN'
            ? event.target.querySelector('strong').innerText
            : event.target.closest('span')?.querySelector('strong').innerText;
            setoddsValue(backPriceData.price);
            setPriceGet(oneClickValue)
            onBetClick({ eventid: receivedMatchodds?.finalResult?.[0]?.eventId, marketId: receivedMatchodds?.finalResult?.[0].marketId, stake: oneClickValue*1, bklyClassValue:toggleclass, selectionName: runnerName, secId: runnerId, oddsValue:backPriceData.price })
    }

    useEffect(()=>{
        if(isBetUpdate){
            betNotUpdated();
        }
    },[isBetUpdate])

    useEffect(() => {
        let intervalId;
        const userinfo = sessionStorage.getItem('userinfo');
        if (userinfo) {
            if (isConnected) {
                handleSendMarketBookDetails();
            }
        }
        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [isConnected]);


    const toggleHandle = (slideId, bklyClass, event, runnerName,backPriceData) => {
        const strongElement = event.target.tagName === 'SPAN'
            ? event.target.querySelector('strong').innerText
            : event.target.closest('span')?.querySelector('strong').innerText;
        setSlideToggle(slideToggle === slideId ? slideId : slideId);
        setBklyClass(bklyClass);
        setoddsValue(backPriceData.price);
        setSecIds(slideId);
        setBeton(runnerName)
        setPriceGet('')
    }

    const handlecloseSlip =() => {
        clearCashout()
        setSlideToggle(false);
        clearSecId();
        handleSendMarketBookDetails();
        // setPriceGet(0);
    }

    const handleIncrementOdds = (event) => {
        setOldOddsValue(oddsValue);
        setEventObj(event);
        setoddsValue(parseFloat((Number(oddsValue) + 0.01)).toFixed(2))
      };

    const handleDecrementOdds = (event) => {
        setOldOddsValue(oddsValue);
        setEventObj(event);
        setoddsValue(parseFloat((Number(oddsValue) - 0.01)).toFixed(2))
      };


    useEffect(() => {
        if (getMatchOdds?.status !== 'OPEN' || getMatchOdds?.runners?.some(runner => runner.status !== "ACTIVE")) {
            setSlideToggle(false);
        }
        // console.log(getMatchOdds,'---------------getMatchOdds');

    }, [getMatchOdds]);

    const checkUpdateOdds = (oddItem,targetClass,targetId) => {
        removeBackgroundColor();
        // const targetElement = document.getElementById(targetId);

         // Use querySelector to target based on class and data-id
         const targetElement = document.querySelector(`.${targetClass}#${targetId}[data-id="${oddItem.runnerId}"]`);

        // console.log("Element found: ", targetElement);
        if (
            targetElement
        ) {
            // console.log(oddItem.runnerId,targetClass, targetElement.querySelector('strong')?.innerText.trim(),"-----------------------");
            return targetElement.querySelector('strong')?.innerText.trim() || 0;
            // const smallText = targetElement.querySelector('small')?.innerText.trim() || null;

        } else {
            // console.log("Element not found or does not match criteria!", oddItem.runnerId, targetClass, targetId);
            return 0;
        }
    }

    const checkUpdateSize = (oddItem,targetClass,targetId) => {
        removeBackgroundColor();
        // const targetElement = document.getElementById(targetId);

         // Use querySelector to target based on class and data-id
         const targetElement = document.querySelector(`.${targetClass}#${targetId}[data-id="${oddItem.runnerId}"]`);

        // console.log("Element found: ", targetElement);
        if (
            targetElement
        ) {
            // console.log(oddItem.runnerId,targetClass, targetElement.querySelector('strong')?.innerText.trim(),"-----------------------");
            return targetElement.querySelector('small')?.innerText.trim() || 0;
            // const smallText = targetElement.querySelector('small')?.innerText.trim() || null;

        } else {
            // console.log("Element not found or does not match criteria!", oddItem.runnerId, targetClass, targetId);
            return 0;
        }
    }

    const formatNumber = (num) => {
        if (num >= 1000000000) {
          return (num / 1000000000).toFixed(2) + 'B'; // Billion
        } else if (num >= 1000000) {
          return (num / 1000000).toFixed(2) + 'M'; // Million
        } else if (num >= 1000) {
          return (num / 1000).toFixed(2) + 'K'; // Thousand
        } else {
          return num; // Less than 1000
        }
      };

      const formatNumberinStack = (num) => {
        if (num >= 1000000000) {
          return (num / 1000000000) + 'B'; // Billion
        } else if (num >= 1000000) {
          return (num / 1000000) + 'M'; // Million
        } else if (num >= 1000) {
          return (num / 1000) + 'K'; // Thousand
        } else {
          return num; // Less than 1000
        }
      };

      function isSuspended(receivedMatchodds, getMatchOdds, index) {
        // Check the conditions for suspension
        // console.log(receivedMatchodds?.finalResult[0].marketType,"----", , "-------receivedMatchodds?.finalResult[0].resumesuspendstatus");

        if (receivedMatchodds?.finalResult[0].resumesuspendstatus) {
          if (getMatchOdds?.status !== 'OPEN' || getMatchOdds?.runners?.[index]?.status !== 'ACTIVE') {
            return true;
          }
        } else {
          return true;
        }
        return false;
      }

      const convertToOriginalValue = (shorthand) => {
        // Ensure shorthand is a string
        if (typeof shorthand !== 'string') {
            return shorthand; // Return the value as is if it's not a string
        }

        const value = parseFloat(shorthand); // Extract numeric part
        if (shorthand.toUpperCase().endsWith('K')) {
            return value * 1_000; // Multiply by 1,000 for 'K'
        } else if (shorthand.toUpperCase().endsWith('M')) {
            return value * 1_000_000; // Multiply by 1,000,000 for 'M'
        }
        return value; // Return the numeric value if no suffix
    };

    const allValue = () => {
        let userinfo = sessionStorage.getItem('balance');
        if (userinfo !== null) {
            let data = JSON.parse(userinfo);
            return (data.availableBalance - data.totalExposure).toFixed(2);
        }else{
            return 0;
        }
    };

    const mutliMarketAddRemove =(marketID,evenID) =>{
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Authorization", `Bearer ${sessionStorage.getItem("token")}`);

        const raw = JSON.stringify({
            marketId: marketID,
            eventId: evenID
        });

        const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
        };

        fetch(`${process.env.REACT_APP_BASE_URL}/armultimarket`, requestOptions)
        .then(async (response) => {
            let paresData = await response.json();
            if(response.ok){
                setMultimarketArray(paresData.marketId)
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
    }
    const isMarketIdPresent = (multimarketArray, receivedMatchodds) => {
        return multimarketArray.includes(receivedMatchodds?.finalResult?.[0]?.marketId);
    };

    const isMarketIdPresentUnderOver = (multimarketArray, marketId) => {
        return multimarketArray.includes(marketId);
    };

    const getmatchOddsUpdate = (getMatchOdds,runnerId) => {
        let deta = getMatchOdds?.runners?.find(runner => runner.runnerId == runnerId);
        // console.log(deta,"----------------deta");

        return deta;
    }

    function removeBackgroundColor() {
        const spans = document.querySelectorAll('.box .blue');
        spans.forEach((span) => {
            // Check if the span has a yellow background color
            if (span.style.backgroundColor === 'gold') {
                // Set an interval to remove the background color after 0.3 seconds
                setTimeout(() => {
                    span.style.backgroundColor = ''; // Remove background color
                }, 200); // 300ms (0.3 seconds)
            }
        });

        const spans1 = document.querySelectorAll('.box .pink');
        spans1.forEach((span) => {
            // Check if the span has a yellow background color
            if (span.style.backgroundColor === 'gold') {
                // Set an interval to remove the background color after 0.3 seconds
                setTimeout(() => {
                    span.style.backgroundColor = ''; // Remove background color
                }, 200); // 300ms (0.3 seconds)
            }
        });
    }

    return (
        <>
            {eventAccess?.matchoddStatus ? <div className='sport-all-data inner-match-list'>
                <div className='match-wrapper'>
                    <Accordion transition transitionTimeout={350}>
                        <AccordionItem initialEntered header={
                            <div className={`heading ${sessionStorage.getItem('userId') ? 'w-star':''}`}>
                                            <div className='heading-text sport-name'>
                                                Match Odds <span className='rulespopup-btn' onClick={grulesHandle}><i className="fa-solid fa-circle-info"></i></span>
                                            </div>
                                            <div className='heading-text sport-name'>
                                                Min : {receivedMatchodds?.finalResult?.[0]?.min_stake}, Max : {receivedMatchodds?.finalResult?.[0]?.max_stake}
                                            </div>
                                            {sessionStorage.getItem('userId') ? (
                                                isMarketIdPresent(multimarketArray,receivedMatchodds) ? (<svg className='star-icon' onClick={()=>mutliMarketAddRemove(receivedMatchodds?.finalResult?.[0].marketId,eventAccess?.matchData?.eventId)} xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3834 1.13606C13.0434 -0.201277 14.9514 -0.201277 15.6114 1.13606L18.7554 7.50672L25.7861 8.52806C27.2621 8.74139 27.8514 10.5574 26.7834 11.5987L25.5754 12.7761C24.0802 11.9352 22.3691 11.557 20.6588 11.6894C18.9485 11.8217 17.3159 12.4586 15.9678 13.5194C14.6198 14.5802 13.6168 16.0172 13.086 17.6484C12.5552 19.2797 12.5204 21.0317 12.9861 22.6827L7.71006 25.4561C6.39006 26.1494 4.84606 25.0294 5.09672 23.5587L6.29806 16.5574L1.21139 11.5974C0.143391 10.5574 0.732724 8.74272 2.20872 8.52806L9.23939 7.50672L12.3834 1.13606ZM28.6634 20.3334C28.6634 18.3885 27.8908 16.5232 26.5155 15.1479C25.1402 13.7727 23.275 13.0001 21.3301 13.0001C19.3851 13.0001 17.5199 13.7727 16.1446 15.1479C14.7693 16.5232 13.9967 18.3885 13.9967 20.3334C13.9967 22.2783 14.7693 24.1436 16.1446 25.5188C17.5199 26.8941 19.3851 27.6667 21.3301 27.6667C23.275 27.6667 25.1402 26.8941 26.5155 25.5188C27.8908 24.1436 28.6634 22.2783 28.6634 20.3334ZM21.9967 21.0001L21.9994 24.3374C21.9994 24.5142 21.9292 24.6838 21.8041 24.8088C21.6791 24.9338 21.5095 25.0041 21.3327 25.0041C21.1559 25.0041 20.9863 24.9338 20.8613 24.8088C20.7363 24.6838 20.6661 24.5142 20.6661 24.3374V21.0001H17.3261C17.1492 21.0001 16.9797 20.9298 16.8547 20.8048C16.7296 20.6798 16.6594 20.5102 16.6594 20.3334C16.6594 20.1566 16.7296 19.987 16.8547 19.862C16.9797 19.737 17.1492 19.6667 17.3261 19.6667H20.6661L20.6647 16.3321C20.6647 16.1552 20.735 15.9857 20.86 15.8607C20.985 15.7356 21.1546 15.6654 21.3314 15.6654C21.5082 15.6654 21.6778 15.7356 21.8028 15.8607C21.9278 15.9857 21.9981 16.1552 21.9981 16.3321V19.6654H25.3274C25.5042 19.6654 25.6738 19.7356 25.7988 19.8607C25.9238 19.9857 25.9941 20.1552 25.9941 20.3321C25.9941 20.5089 25.9238 20.6784 25.7988 20.8035C25.6738 20.9285 25.5042 20.9987 25.3274 20.9987H21.9994L21.9967 21.0001Z" fill="#182EA6"></path>
                                                    </svg>
                                                ) :(<svg onClick={()=> mutliMarketAddRemove(receivedMatchodds?.finalResult?.[0].marketId,eventAccess?.matchData?.eventId)} className='star-icon' xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                        <path d="M12.3839 1.136C13.0439 -0.201338 14.9519 -0.201338 15.6119 1.136L18.7559 7.50666L25.7865 8.528C27.2625 8.74133 27.8519 10.5573 26.7839 11.5987L25.5772 12.7747C24.9405 12.4162 24.2609 12.1402 23.5545 11.9533L25.0972 10.4493L18.3639 9.47066C18.0751 9.42853 17.8009 9.31683 17.5649 9.14518C17.3289 8.97353 17.1382 8.74708 17.0092 8.48533L13.9972 2.38666L10.9865 8.48533C10.8575 8.74708 10.6668 8.97353 10.4308 9.14518C10.1948 9.31683 9.92064 9.42853 9.63188 9.47066L2.89855 10.4493L7.77055 15.1987C8.19455 15.612 8.38788 16.208 8.28788 16.792L7.13855 23.4973L12.6705 20.5893C12.6905 21.312 12.8012 22.012 12.9879 22.6813L7.71055 25.456C6.39055 26.1493 4.84655 25.0293 5.09721 23.5587L6.29855 16.5573L1.21188 11.5973C0.143879 10.5573 0.733212 8.74266 2.20921 8.528L9.23988 7.50666L12.3839 1.136ZM28.6665 20.3333C28.6665 18.3884 27.8939 16.5231 26.5187 15.1479C25.1434 13.7726 23.2781 13 21.3332 13C19.3883 13 17.523 13.7726 16.1478 15.1479C14.7725 16.5231 13.9999 18.3884 13.9999 20.3333C13.9999 22.2783 14.7725 24.1435 16.1478 25.5188C17.523 26.894 19.3883 27.6667 21.3332 27.6667C23.2781 27.6667 25.1434 26.894 26.5187 25.5188C27.8939 24.1435 28.6665 22.2783 28.6665 20.3333ZM21.9999 21L22.0012 24.3373C22.0012 24.5141 21.931 24.6837 21.8059 24.8087C21.6809 24.9338 21.5114 25.004 21.3345 25.004C21.1577 25.004 20.9882 24.9338 20.8631 24.8087C20.7381 24.6837 20.6679 24.5141 20.6679 24.3373V21H17.3279C17.1511 21 16.9815 20.9298 16.8565 20.8047C16.7314 20.6797 16.6612 20.5101 16.6612 20.3333C16.6612 20.1565 16.7314 19.9869 16.8565 19.8619C16.9815 19.7369 17.1511 19.6667 17.3279 19.6667H20.6665V16.332C20.6665 16.1552 20.7368 15.9856 20.8618 15.8606C20.9868 15.7356 21.1564 15.6653 21.3332 15.6653C21.51 15.6653 21.6796 15.7356 21.8046 15.8606C21.9296 15.9856 21.9999 16.1552 21.9999 16.332V19.6653H25.3292C25.506 19.6653 25.6756 19.7356 25.8006 19.8606C25.9256 19.9856 25.9959 20.1552 25.9959 20.332C25.9959 20.5088 25.9256 20.6784 25.8006 20.8034C25.6756 20.9284 25.506 20.9987 25.3292 20.9987L21.9999 21Z" fill="#182EA6"/>
                                                    </svg>
                                                )
                                            ) :'' }
                                        </div>}
                                        >
                                        <div className='heading match-heading'>
                                            <div className='heading-text sport-name'>
                                                Market
                                            </div>
                                            {(receivedBookData && receivedBookData.showData && receivedBookData.showData.length !== 0 && receivedMatchodds?.finalResult?.[0]?.runners.length === 2) ?
                                                <><div className='cashout-btn'>
                                                    <button onClick={handleCashOut} className='btn'>Cashout</button>
                                                </div></>
                                                : null
                                            }
                                            <div className='odds-heading'>
                                                <div className='heading-text box blue'>Back</div>
                                                <div className='heading-text box pink'>Lay</div>
                                            </div>
                                        </div>
                                        <div className='match-data'>
                                            <div className='match-list' id={receivedMatchodds?.finalResult?.[0].marketId}>
                                                {receivedMatchodds?.finalResult?.[0]?.runners.map((oddItem, index) => (
                                                    <div className='data-with-betslip' key={index} id={oddItem.runnerId}>
                                                        <div className='match-info-row'>
                                                            <div className='match-name'>{oddItem.runnerName}</div>
                                                            <div className={`${(receivedBookData && receivedBookData.showData && receivedBookData.showData.length !== 0
                                                                && receivedBookData.showData.find(item => item.runnerId === oddItem.runnerId)?.amount < 0)
                                                                ? 'red-txt'
                                                                : 'green-txt'} book-value`}>
                                                            {receivedBookData && receivedBookData.showData && receivedBookData.showData.length !== 0
                                                                ? (receivedBookData.showData.find(item => item.runnerId === oddItem.runnerId)?.amount || 0)
                                                                : ''
                                                            }
                                                            </div>
                                                            <div className='match-odds'>

                                                            {isSuspended(receivedMatchodds, getMatchOdds, index) &&  (
                                                            <>
                                                            <div className='suspended'>Suspended</div>
                                                            {/* {clearSecId()}
                                                            {unsetBetLoader()} */}
                                                            </>
                                                            )}

                                                            <div className='box'>
                                                            {(() => {
                                                                const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[2];
                                                                const backPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[2];
                                                                return (
                                                                    <span
                                                                        key={2}
                                                                        className={`blue ${!backPriceExists || (backPriceData && backPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < backPriceData?.price ? 'disable' : ''}`}
                                                                        style={{backgroundColor:checkUpdateOdds(oddItem, "blue", "id-2") == backPriceData?.price || checkUpdateSize(oddItem, "blue", "id-2") == formatNumber(backPriceData?.size)? 'gold' : 'revert-layer'}}
                                                                        data-id={oddItem.runnerId}
                                                                        id='id-2'
                                                                        onClick={(event) => {
                                                                            if (!isBetLoader) {
                                                                                if (backPriceExists) {
                                                                                    handleSendMarketBookDetails();
                                                                                    if (isOneClicked === "true") {
                                                                                        onClickFunction(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    } else {
                                                                                        toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {receivedMatchodds?.finalResult[0].resumesuspendstatus &&
                                                                        getMatchOdds?.status === 'OPEN' &&
                                                                        getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                        (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null) ? (
                                                                            <>
                                                                                <strong>{backPriceData?.price}</strong>
                                                                                <small>
                                                                                    {formatNumber(backPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                        ) : (
                                                                            <i className="fa fa-lock"></i>
                                                                        )}
                                                                    </span>
                                                                );
                                                            })()}

                                                            {(() => {
                                                                const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[1];
                                                                const backPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[1];
                                                                return (
                                                                    <span
                                                                        key={1}
                                                                        className={`blue ${!backPriceExists || (backPriceData && backPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < backPriceData?.price ? 'disable' : ''}`}
                                                                        data-id={oddItem.runnerId}
                                                                        style={{backgroundColor:checkUpdateOdds(oddItem, "blue", "id-1") == backPriceData?.price || checkUpdateSize(oddItem, "blue", "id-1") == formatNumber(backPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                                        id='id-1'
                                                                        onClick={(event) => {
                                                                            if (!isBetLoader) {
                                                                                if (backPriceExists) {
                                                                                    handleSendMarketBookDetails();
                                                                                    if (isOneClicked === "true") {
                                                                                        onClickFunction(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    } else {
                                                                                        toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {receivedMatchodds?.finalResult[0].resumesuspendstatus &&
                                                                        getMatchOdds?.status === 'OPEN' &&
                                                                        getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                        (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null) ? (
                                                                            <>
                                                                                <strong>{backPriceData?.price}</strong>
                                                                                <small>
                                                                                    {formatNumber(backPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                        ) : (
                                                                            <i className="fa fa-lock"></i>
                                                                        )}
                                                                    </span>
                                                                );
                                                            })()}


                                                            {(() => {
                                                                const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[0];
                                                                const backPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0];
                                                                return (
                                                                    <span
                                                                        key={0}
                                                                        className={`blue ${!backPriceExists || (backPriceData && backPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < backPriceData?.price ? 'disable' : ''}`}
                                                                        data-id={oddItem.runnerId}
                                                                        style={{backgroundColor:checkUpdateOdds(oddItem, "blue", "id-0") == backPriceData?.price || checkUpdateSize(oddItem, "blue", "id-0") == formatNumber(backPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                                        id='id-0'
                                                                        onClick={(event) => {
                                                                            if (!isBetLoader) {
                                                                                if (backPriceExists) {
                                                                                    handleSendMarketBookDetails();
                                                                                    if (isOneClicked === "true") {
                                                                                        onClickFunction(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    } else {
                                                                                        toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.backPrices?.[0]);
                                                                                    }
                                                                                }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {receivedMatchodds?.finalResult[0].resumesuspendstatus &&
                                                                        getMatchOdds?.status === 'OPEN' &&
                                                                        getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                        (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null) ? (
                                                                            <>
                                                                                <strong>{backPriceData?.price}</strong>
                                                                                <small>
                                                                                    {formatNumber(backPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                        ) : (
                                                                            <i className="fa fa-lock"></i>
                                                                        )}
                                                                    </span>
                                                                );
                                                            })()}
                                                            </div>


                                                                <div className='box'>
                                                                {(() => {
                                                                    const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[0];
                                                                    const layPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[0];
                                                                    let flag = checkUpdateOdds(oddItem,"pink", 'id-0') == layPriceData?.price
                                                                    return (
                                                                        <span
                                                                        key={0}
                                                                        className={`pink ${!layPriceExists || (layPriceData && layPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < layPriceData?.price ? 'disable' : ''}`}
                                                                        style={{backgroundColor: checkUpdateOdds(oddItem,"pink", 'id-0') == layPriceData?.price || checkUpdateSize(oddItem, "pink", "id-0") == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                                        data-id={oddItem.runnerId}
                                                                        id='id-0'
                                                                        onClick={(event) => {
                                                                            if(!isBetLoader){
                                                                            if (layPriceExists) {
                                                                                handleSendMarketBookDetails();
                                                                                if (isOneClicked === 'true') {
                                                                                    onClickFunction(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[0]);
                                                                                } else {
                                                                                    toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[0]);
                                                                                }
                                                                            }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            receivedMatchodds?.finalResult[0]?.resumesuspendstatus &&
                                                                            getMatchOdds?.status === 'OPEN' &&
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId) && // Check for undefined here
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                            (layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null) ? (
                                                                                <>
                                                                                <strong>{layPriceData?.price}</strong>
                                                                                <small>
                                                                                {formatNumber(layPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                            ) : (
                                                                                <i className="fa fa-lock"></i>
                                                                            )
                                                                        }
                                                                    </span>
                                                                    );
                                                                })()}

                                                                {(() => {
                                                                    const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[1];
                                                                    const layPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[1];
                                                                    let flag = checkUpdateOdds(oddItem,"pink", 'id-1') == layPriceData?.price
                                                                    return (
                                                                        <span
                                                                        key={1}
                                                                        className={`pink ${!layPriceExists || (layPriceData && layPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < layPriceData?.price ? 'disable' : ''}`}
                                                                        style={{backgroundColor: checkUpdateOdds(oddItem,"pink", 'id-1') == layPriceData?.price || checkUpdateSize(oddItem, "pink", "id-1") == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                                        data-id={oddItem.runnerId}
                                                                        id='id-1'
                                                                        onClick={(event) => {
                                                                            if(!isBetLoader){
                                                                            if (layPriceExists) {
                                                                                handleSendMarketBookDetails();
                                                                                if (isOneClicked === 'true') {
                                                                                    onClickFunction(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[1]);
                                                                                } else {
                                                                                    toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[1]);
                                                                                }
                                                                            }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            receivedMatchodds?.finalResult[0]?.resumesuspendstatus &&
                                                                            getMatchOdds?.status === 'OPEN' &&
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId) && // Check for undefined here
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                            (layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null) ? (
                                                                                <>
                                                                                <strong>{layPriceData?.price}</strong>
                                                                                <small>
                                                                                {formatNumber(layPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                            ) : (
                                                                                <i className="fa fa-lock"></i>
                                                                            )
                                                                        }
                                                                    </span>
                                                                    );
                                                                })()}

                                                                {(() => {
                                                                    const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[2];
                                                                    const layPriceData = getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[2];
                                                                    let flag = checkUpdateOdds(oddItem,"pink", 'id-2') == layPriceData?.price
                                                                    return (
                                                                        <span
                                                                        key={2}
                                                                        className={`pink ${!layPriceExists || (layPriceData && layPriceData.price === 0) ? 'lock' : ''} ${receivedMatchodds?.finalResult?.[0]?.max_odd < layPriceData?.price ? 'disable' : ''}`}
                                                                        style={{backgroundColor: checkUpdateOdds(oddItem,"pink", 'id-2') == layPriceData?.price || checkUpdateSize(oddItem, "pink", "id-2") == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                                        data-id={oddItem.runnerId}
                                                                        id='id-2'
                                                                        onClick={(event) => {
                                                                            if(!isBetLoader){
                                                                            if (layPriceExists) {
                                                                                handleSendMarketBookDetails();
                                                                                if (isOneClicked === 'true') {
                                                                                    onClickFunction(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[2]);
                                                                                } else {
                                                                                    toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName,getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.layPrices?.[2]);
                                                                                }
                                                                            }
                                                                            }
                                                                        }}
                                                                    >
                                                                        {
                                                                            receivedMatchodds?.finalResult[0]?.resumesuspendstatus &&
                                                                            getMatchOdds?.status === 'OPEN' &&
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId) && // Check for undefined here
                                                                            getmatchOddsUpdate(getMatchOdds,oddItem.runnerId)?.status === 'ACTIVE' &&
                                                                            (layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null) ? (
                                                                                <>
                                                                                <strong>{layPriceData?.price}</strong>
                                                                                <small>
                                                                                {formatNumber(layPriceData?.size)}
                                                                                </small>
                                                                            </>
                                                                            ) : (
                                                                                <i className="fa fa-lock"></i>
                                                                            )
                                                                        }
                                                                    </span>
                                                                    );
                                                                })()}

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={getBetSlipClasss(oddItem)}>
                                                                <div className={`betslip ${direactsecId === oddItem.runnerId ? 'active' : ''} ${bklyClassValue}`}>

                                                                    <div className="close-btn" onClick={handlecloseSlip}>×</div>
                                                                    <div className="betslip-top">
                                                                        <div className="bet-selection-name" >Bet on : {Beton} @{oddsValue}</div>
                                                                        <div className="bet-profit"></div>
                                                                        <div className="betslip-odds betslip-stake">
                                                                            <strong>Odds</strong>
                                                                            <div className='input-group'>
                                                                                                    <span onClick={(event) => handleDecrementOdds(event)}>-</span>
                                                                                                    <input type="text" value={oddsValue} />
                                                                                                    <span onClick={(event) => handleIncrementOdds(event)}>+</span>
                                                                                                </div>
                                                                        </div>
                                                                        <div className="betslip-stake">
                                                                            <strong>Stake</strong>
                                                                            <div className="input-group">
                                                                                <span className="minus" onClick={(event) => subtractValue(event)}>-</span>
                                                                                <input type="text" value={priceGet} className="set-stake-form-input" onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            let old = priceGet
                        setPriceGet(value);
                        updateBook(e,old,value);
                        }
                    }}  aria-label="Last name"
                    autoFocus="" maxLength="8" />
                                                                                <span className="plus" onClick={(event) => PlusValue(event)}>+</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="betslip-placebutton">
                                                                        <div className="price-btns">
                                                                        {Array.isArray(stack) && stack.map((item,index) => (
                                                                                <span key={index} id={`${item}`} onClick={(event) => addValue(`${item}`,event)}>{formatNumberinStack(item)}</span>
                                                                            )) }
                                                                            <span id="1000" className="MAX" onClick={(event)=>addAllValue(`${convertToOriginalValue(receivedMatchodds?.finalResult?.[0]?.max_stake)}`,event)}>MAX</span>
                                                                            <span id="1000" className="MAX" onClick={(event)=>addAllValue(`${allValue()}`,event)}>All</span>
                                                                        </div>
                                                                        <div className="betplace-btn">
                                                                            {isLoggedIn || loggedIn ? <button className="place-bet" onClick={(event) =>{
                                                                                onBetClick({ eventid: receivedMatchodds?.finalResult?.[0]?.eventId, marketId: receivedMatchodds?.finalResult?.[0].marketId, stake: priceGet, bklyClassValue, selectionName: oddItem.runnerName, secId: oddItem.runnerId, oddsValue })
                                                                            } }>Place Bet</button> : <button onClick={openPopup} className="login-btn">Login to continue</button>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className={`betslip_mobileview ${direactsecId === oddItem.runnerId ? 'active' : ''} ${bklyClassValue}`}>
                                                                    <div className="close-btn" onClick={handlecloseSlip}>×</div>
                                                                    <table className="eventdetails">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    <div className='plus-minus-wraper'>
                                                                                    <div className='plus-minus'>
                                                                                        <span onClick={(event) => handleDecrementOdds(event)}>-</span>
                                                                                        <input type="text" value={oddsValue} />
                                                                                        <span onClick={(event) => handleIncrementOdds(event)}>+</span>
                                                                                    </div>
                                                                                    <div className='plus-minus'>
                                                                                        <span onClick={(event) => subtractValue(event)}>-</span>
                                                                                        <input type="text" value={priceGet} className="set-stake-form-input" onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                            let old = priceGet
                        setPriceGet(value);
                        updateBook(e,old,value);
                        }
                    }}  aria-label="Last name" autoFocus="" maxLength="8" />
                                                                                        <span onClick={(event) => PlusValue(event)} >+</span>
                                                                                    </div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr>
                                                                                <td colSpan="11" className='mbet-slip'>
                                                                                    <div className="mbet-slip-wraper">
                                                                                    {Array.isArray(stack) && stack.map((item,index) => (
                                                                                        <div key={index} id={`${item}`} className="odds-value" onClick={(event) => addValue(`${item}`,event)}>{formatNumberinStack(item)}</div>
                                                                                    )) }
                                                                                        <div className="odds-value max" onClick={(event)=>addAllValue(`${convertToOriginalValue(receivedMatchodds?.finalResult?.[0]?.max_stake)}`,event)} id="10000">MAX</div>
                                                                                        <div className="odds-value all" onClick={(event)=>addAllValue(`${allValue()}`,event)} id="98941.80">ALL IN</div>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                            <tr className="numbering">
                                                                                <td colSpan="11">
                                                                                    <table>
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td><span onClick={(event) => incrementValue('1',event)} id="1">1</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('2',event)} id="2">2</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('3',event)} id="3">3</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('4',event)} id="4">4</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('5',event)} id="5">5</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('6',event)} id="6">6</span></td>
                                                                                                <td rowSpan="2"><span className="back-span" onClick={(event) => removeLastDigit(event)}><img alt="" src={betslipclosearrow} decoding="async" loading="lazy"/></span></td>
                                                                                            </tr>
                                                                                            <tr>
                                                                                                <td><span onClick={(event) => incrementValue('7',event)} id="7">7</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('8',event)} id="8">8</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('9',event)} id="9">9</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('0',event)} id="0">0</span></td>
                                                                                                <td><span onClick={(event) => incrementValue('00',event)} id="double0">00</span></td>
                                                                                                {/* <td><span onClick={(event) => incrementValue('000',event)} id="dot">000</span></td> */}
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                            <tr className="bet-btns">
                                                                                <td colSpan="11">
                                                                                    <div className="btn-wraper">
                                                                                        <button className="btn cancel-bet" onClick={handlecloseSlip}>CANCEL</button>
                                                                                        {isLoggedIn || loggedIn ? <button className="btn place-bet" onClick={(event) => {
                                                                                            onBetClick({ eventid: receivedMatchodds?.finalResult?.[0]?.eventId, marketId: receivedMatchodds?.finalResult?.[0].marketId, stake: priceGet, bklyClassValue, selectionName: oddItem.runnerName, secId: oddItem.runnerId, oddsValue })
                                                                                        }}>Place Bet</button> : <button onClick={openPopup} className="btn login-btn">Login to continue</button>}
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            {isBetLoader ?
                                                        <div className="loader-sec loading">
                                                            Placing Your Bet, Please Wait <div className='loader-box'><span className='loading-number'>{String(loaderCounter).padStart(2, '0')}</span><span className='loader'></span></div>
                                                            </div> : ''}
                                                        </div>
                                                    </div>
                                                ))}
                                                {myNotification && myNotification.length > 0 && <SubNotification isFancy={false} msg={myNotification && myNotification.find(noti => noti.marketId == eventAccess?.matchoddId)?.notifications} />}
                                                
                                            </div>

                                        </div>
                        </AccordionItem>
                    </Accordion>


                </div>
            </div> : ''}
            {items.map((_, i) => (
                    eventAccess?.[`overunder${i}Status`] ? (
                        <div key={i} className='sport-all-data inner-match-list'>
                        <div className='match-wrapper'>
                        <Accordion transition transitionTimeout={350}>
                        <AccordionItem initialEntered header={<div className={`heading ${sessionStorage.getItem('userId') ? 'w-star':''}`}>
                                    <div className='heading-text sport-name'>
                                    {eval(`receivedunderOve${i}`)?.finalResult?.[0]?.marketName}  <span className='rulespopup-btn' onClick={grulesHandle}><i className="fa-solid fa-circle-info"></i></span>
                                    </div>
                                    <div className='heading-text sport-name'>
                                    {/* {console.log(eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd,"*-*-*-*-*-*-*-*-*-*-*-")} */}
                                        Min : {eval(`receivedunderOve${i}`)?.finalResult?.[0]?.min_stake}, Max : {eval(`receivedunderOve${i}`)?.finalResult?.[0]?.max_stake}
                                    </div>
                                    {sessionStorage.getItem('userId') ? (
                                        isMarketIdPresentUnderOver(multimarketArray,eval(`receivedunderOve${i}`)?.finalResult?.[0]?.marketId) ? (<svg className='star-icon' onClick={()=>mutliMarketAddRemove(eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId,eventAccess?.matchData?.eventId)} xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                <path d="M12.3834 1.13606C13.0434 -0.201277 14.9514 -0.201277 15.6114 1.13606L18.7554 7.50672L25.7861 8.52806C27.2621 8.74139 27.8514 10.5574 26.7834 11.5987L25.5754 12.7761C24.0802 11.9352 22.3691 11.557 20.6588 11.6894C18.9485 11.8217 17.3159 12.4586 15.9678 13.5194C14.6198 14.5802 13.6168 16.0172 13.086 17.6484C12.5552 19.2797 12.5204 21.0317 12.9861 22.6827L7.71006 25.4561C6.39006 26.1494 4.84606 25.0294 5.09672 23.5587L6.29806 16.5574L1.21139 11.5974C0.143391 10.5574 0.732724 8.74272 2.20872 8.52806L9.23939 7.50672L12.3834 1.13606ZM28.6634 20.3334C28.6634 18.3885 27.8908 16.5232 26.5155 15.1479C25.1402 13.7727 23.275 13.0001 21.3301 13.0001C19.3851 13.0001 17.5199 13.7727 16.1446 15.1479C14.7693 16.5232 13.9967 18.3885 13.9967 20.3334C13.9967 22.2783 14.7693 24.1436 16.1446 25.5188C17.5199 26.8941 19.3851 27.6667 21.3301 27.6667C23.275 27.6667 25.1402 26.8941 26.5155 25.5188C27.8908 24.1436 28.6634 22.2783 28.6634 20.3334ZM21.9967 21.0001L21.9994 24.3374C21.9994 24.5142 21.9292 24.6838 21.8041 24.8088C21.6791 24.9338 21.5095 25.0041 21.3327 25.0041C21.1559 25.0041 20.9863 24.9338 20.8613 24.8088C20.7363 24.6838 20.6661 24.5142 20.6661 24.3374V21.0001H17.3261C17.1492 21.0001 16.9797 20.9298 16.8547 20.8048C16.7296 20.6798 16.6594 20.5102 16.6594 20.3334C16.6594 20.1566 16.7296 19.987 16.8547 19.862C16.9797 19.737 17.1492 19.6667 17.3261 19.6667H20.6661L20.6647 16.3321C20.6647 16.1552 20.735 15.9857 20.86 15.8607C20.985 15.7356 21.1546 15.6654 21.3314 15.6654C21.5082 15.6654 21.6778 15.7356 21.8028 15.8607C21.9278 15.9857 21.9981 16.1552 21.9981 16.3321V19.6654H25.3274C25.5042 19.6654 25.6738 19.7356 25.7988 19.8607C25.9238 19.9857 25.9941 20.1552 25.9941 20.3321C25.9941 20.5089 25.9238 20.6784 25.7988 20.8035C25.6738 20.9285 25.5042 20.9987 25.3274 20.9987H21.9994L21.9967 21.0001Z" fill="#182EA6"></path>
                                            </svg>
                                        ) :(<svg onClick={()=> mutliMarketAddRemove(eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId,eventAccess?.matchData?.eventId)} className='star-icon' xmlns="http://www.w3.org/2000/svg" width="29" height="28" viewBox="0 0 29 28" fill="none">
                                                <path d="M12.3839 1.136C13.0439 -0.201338 14.9519 -0.201338 15.6119 1.136L18.7559 7.50666L25.7865 8.528C27.2625 8.74133 27.8519 10.5573 26.7839 11.5987L25.5772 12.7747C24.9405 12.4162 24.2609 12.1402 23.5545 11.9533L25.0972 10.4493L18.3639 9.47066C18.0751 9.42853 17.8009 9.31683 17.5649 9.14518C17.3289 8.97353 17.1382 8.74708 17.0092 8.48533L13.9972 2.38666L10.9865 8.48533C10.8575 8.74708 10.6668 8.97353 10.4308 9.14518C10.1948 9.31683 9.92064 9.42853 9.63188 9.47066L2.89855 10.4493L7.77055 15.1987C8.19455 15.612 8.38788 16.208 8.28788 16.792L7.13855 23.4973L12.6705 20.5893C12.6905 21.312 12.8012 22.012 12.9879 22.6813L7.71055 25.456C6.39055 26.1493 4.84655 25.0293 5.09721 23.5587L6.29855 16.5573L1.21188 11.5973C0.143879 10.5573 0.733212 8.74266 2.20921 8.528L9.23988 7.50666L12.3839 1.136ZM28.6665 20.3333C28.6665 18.3884 27.8939 16.5231 26.5187 15.1479C25.1434 13.7726 23.2781 13 21.3332 13C19.3883 13 17.523 13.7726 16.1478 15.1479C14.7725 16.5231 13.9999 18.3884 13.9999 20.3333C13.9999 22.2783 14.7725 24.1435 16.1478 25.5188C17.523 26.894 19.3883 27.6667 21.3332 27.6667C23.2781 27.6667 25.1434 26.894 26.5187 25.5188C27.8939 24.1435 28.6665 22.2783 28.6665 20.3333ZM21.9999 21L22.0012 24.3373C22.0012 24.5141 21.931 24.6837 21.8059 24.8087C21.6809 24.9338 21.5114 25.004 21.3345 25.004C21.1577 25.004 20.9882 24.9338 20.8631 24.8087C20.7381 24.6837 20.6679 24.5141 20.6679 24.3373V21H17.3279C17.1511 21 16.9815 20.9298 16.8565 20.8047C16.7314 20.6797 16.6612 20.5101 16.6612 20.3333C16.6612 20.1565 16.7314 19.9869 16.8565 19.8619C16.9815 19.7369 17.1511 19.6667 17.3279 19.6667H20.6665V16.332C20.6665 16.1552 20.7368 15.9856 20.8618 15.8606C20.9868 15.7356 21.1564 15.6653 21.3332 15.6653C21.51 15.6653 21.6796 15.7356 21.8046 15.8606C21.9296 15.9856 21.9999 16.1552 21.9999 16.332V19.6653H25.3292C25.506 19.6653 25.6756 19.7356 25.8006 19.8606C25.9256 19.9856 25.9959 20.1552 25.9959 20.332C25.9959 20.5088 25.9256 20.6784 25.8006 20.8034C25.6756 20.9284 25.506 20.9987 25.3292 20.9987L21.9999 21Z" fill="#182EA6"/>
                                            </svg>
                                        )
                                    ) :'' }
                                </div>} >
                                <div className='heading match-heading'>
                                    <div className='heading-text sport-name'>
                                        Market
                                    </div>

                                    <div className='odds-heading'>
                                    <div className='heading-text box blue'>Back</div>
                                    <div className='heading-text box pink'>Lay</div>
                                    </div>
                                </div>
                                <div className='match-data'>
                                    <div className='match-list under-over' id={eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId}>
                                        {eval(`receivedunderOve${i}`)?.finalResult?.[0]?.runners.map((oddItem, index) => (
                                            <div className='data-with-betslip' key={index} id={oddItem.runnerId}>
                                                <div className='match-info-row'>
                                                    <div className='match-name'>{oddItem.runnerName}</div>
                                                    <div className={`${(receivedBookData && receivedBookData.showData && receivedBookData.showData.length !== 0
                                                        && receivedBookData.showData.find(item => item.runnerId === oddItem.runnerId)?.amount < 0)
                                                        ? 'red-txt'
                                                        : 'green-txt'} book-value`}>
                                                    {receivedBookData && receivedBookData.showData && receivedBookData.showData.length !== 0
                                                        ? (receivedBookData.showData.find(item => item.runnerId === oddItem.runnerId)?.amount || 0)
                                                        : ''
                                                    }
                                                    </div>
                                                    <div className='match-odds'>

                                                    {isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index) &&  (
                                                        <>
                                                        <div className='suspended'>Suspended</div>
                                                        </>
                                                        )}

                                                        <div className='box'>

                                                        {(() => {
                                                            const position = 0;
                                                            const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[position];
                                                            const backPriceData = getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[position];
                                                            let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);
                                                            return (
                                                        <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"blue", `id-${position}`) == backPriceData?.price || checkUpdateSize(oddItem, "blue", `id-${position}`) == formatNumber(backPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                        data-id={oddItem.runnerId}
                                                        id={`id-${position}`}
                                                            className={`blue ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < backPriceData?.price ? 'disable' : ''} ${oddItem?.backPrices && backPriceData?.price !== 0 && backPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                if (isOneClicked === "true") {
                                                                    onClickFunction(oddItem.runnerId, 'back', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                    } else {
                                                                        toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                    }
                                                                }
                                                                }}>

                                                            {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null ?
                                                                    <>
                                                                        <strong>{backPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(backPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>
                                                        )}
                                                            </span>
                                                            );
                                                        })()}

                                                        {(() => {
                                                            const position = 1;
                                                            const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[position];
                                                            const backPriceData = getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[position];
                                                            let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);
                                                            return (
                                                        <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"blue", `id-${position}`) == backPriceData?.price || checkUpdateSize(oddItem, "blue", `id-${position}`) == formatNumber(backPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                            data-id={oddItem.runnerId}
                                                            id={`id-${position}`}
                                                            className={`blue ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < backPriceData?.price ? 'disable' : ''} ${oddItem?.backPrices && backPriceData?.price !== 0 && backPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                    if (isOneClicked === "true") {
                                                                        onClickFunction(oddItem.runnerId, 'back', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                    } else {
                                                                        toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                    }
                                                                }
                                                            }}>

                                                            {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null ?
                                                                    <>
                                                                        <strong>{backPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(backPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>
                                                        )}
                                                            </span>
                                                            );
                                                        })()}

                                                        {(() => {
                                                            const position = 2;
                                                            const backPriceExists = oddItem?.backPrices && oddItem?.backPrices?.slice().reverse()[position];
                                                            const backPriceData = getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[position];
                                                            let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);
                                                            return (
                                                        <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"blue", `id-${position}`) == backPriceData?.price || checkUpdateSize(oddItem, "blue", `id-${position}`) == formatNumber(backPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                            data-id={oddItem.runnerId}
                                                            id={`id-${position}`}
                                                            className={`blue ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < backPriceData?.price ? 'disable' : ''} ${oddItem?.backPrices && backPriceData?.price !== 0 && backPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                if (isOneClicked === "true") {
                                                                    onClickFunction(oddItem.runnerId, 'back', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                } else {
                                                                    toggleHandle(oddItem.runnerId, 'back', event, oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.backPrices.slice().reverse()[2]);
                                                                }
                                                                }
                                                            }}>

                                                            {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (backPriceData?.price != 0 && backPriceData != undefined && backPriceData?.price != null ?
                                                                    <>
                                                                        <strong>{backPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(backPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>
                                                        )}
                                                            </span>
                                                            );
                                                        })()}
                                                        </div>

                                                        <div className='box'>

                                                        {(() => {
                                                        const position = 0;
                                                        const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[position];
                                                        const layPriceData = getUnderOver?.[i]?.runners?.[index]?.layPrices?.[position];
                                                        let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);

                                                        return (
                                                            <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"pink", `id-${position}`) == layPriceData?.price || checkUpdateSize(oddItem, "pink", `id-${position}`) == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                            data-id={oddItem.runnerId}
                                                            id={`id-${position}`}
                                                            className={`pink ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < layPriceData?.price ? 'disable' : ''} ${oddItem?.layPrices && layPriceData?.price !== 0 && layPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                    if (isOneClicked === "true") {
                                                                        onClickFunction(oddItem.runnerId, 'lay', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                    } else {
                                                                        toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName, getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                    }
                                                                }
                                                            }}>

                                                    {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>)}
                                                                {/* {!sus || layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>} */}
                                                        </span>
                                                        );
                                                    })()}

                                                        {(() => {
                                                        const position = 1;
                                                        const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[position];
                                                        const layPriceData = getUnderOver?.[i]?.runners?.[index]?.layPrices?.[position];
                                                        let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);
                                                        return (
                                                            <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"pink", `id-${position}`) == layPriceData?.price || checkUpdateSize(oddItem, "pink", `id-${position}`) == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                            data-id={oddItem.runnerId}
                                                            id={`id-${position}`}
                                                            className={`pink ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < layPriceData?.price ? 'disable' : ''} ${oddItem?.layPrices && layPriceData?.price !== 0 && layPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                    if (isOneClicked === "true") {
                                                                        onClickFunction(oddItem.runnerId, 'lay', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                    } else {
                                                                        toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName, getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                    }
                                                                }
                                                            }}>

                                                    {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>)}
                                                                {/* {!sus || layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>} */}
                                                        </span>
                                                        );
                                                    })()}

                                                        {(() => {
                                                        const position = 2;
                                                        const layPriceExists = oddItem?.layPrices && oddItem?.layPrices[position];
                                                        const layPriceData = getUnderOver?.[i]?.runners?.[index]?.layPrices?.[position];
                                                        let sus = isSuspended(getSelectedReceivedUnderOve(i), getUnderOver?.[i], index);
                                                        return (
                                                            <span
                                                            style={{backgroundColor: checkUpdateOdds(oddItem,"pink", `id-${position}`) == layPriceData?.price || checkUpdateSize(oddItem, "pink", `id-${position}`) == formatNumber(layPriceData?.size) ? 'gold' : 'revert-layer'}}
                                                            data-id={oddItem.runnerId}
                                                            id={`id-${position}`}
                                                            className={`pink ${eval(`receivedunderOve${i}`)?.finalResult?.[0].max_odd < layPriceData?.price ? 'disable' : ''} ${oddItem?.layPrices && layPriceData?.price !== 0 && layPriceData?.price !== 0 ? '' : ' lock'}`}
                                                            onClick={(event) => {
                                                                if(!isBetLoader){
                                                                if (isOneClicked === "true") {
                                                                    onClickFunction(oddItem.runnerId, 'lay', event,oddItem.runnerName,getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                } else {
                                                                    toggleHandle(oddItem.runnerId, 'lay', event, oddItem.runnerName, getUnderOver?.[i]?.runners?.[index]?.layPrices?.[0]);
                                                                }
                                                                }
                                                            }}>

                                                    {sus || getUnderOver?.[i]?.status !== 'OPEN' || getUnderOver?.[i]?.runners?.[index]?.status !== "ACTIVE" ? (
                                                        <i className="fa fa-lock"></i>
                                                        ) : (
                                                            layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>
                                                        )}

                                                                {/* {!sus || layPriceData?.price != 0 && layPriceData != undefined && layPriceData?.price != null ?
                                                                    <>
                                                                    <strong>{layPriceData?.price}</strong>
                                                                        <small>
                                                                            {formatNumber(layPriceData?.size)}
                                                                        </small>
                                                                    </> :
                                                                    <i className="fa fa-lock"></i>} */}
                                                        </span>
                                                        );
                                                    })()}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={getBetSlipClasss(oddItem)}>
                                                        <div className={`betslip ${direactsecId === oddItem.runnerId ? 'active' : ''} ${bklyClassValue}`}>

                                                            <div className="close-btn" onClick={handlecloseSlip}>×</div>
                                                            <div className="betslip-top">
                                                                <div className="bet-selection-name" >Bet on : {Beton} @{oddsValue}</div>
                                                                <div className="bet-profit"></div>
                                                                <div className="betslip-odds betslip-stake">
                                                                    <strong>Odds</strong>
                                                                    <div className='input-group'>
                                                                                <span onClick={(event) => handleDecrementOdds(event)}>-</span>
                                                                                <input type="text" value={oddsValue} />
                                                                                <span onClick={(event) => handleIncrementOdds(event)}>+</span>
                                                                            </div>
                                                                </div>
                                                                <div className="betslip-stake">
                                                                    <strong>Stake</strong>
                                                                    <div className="input-group">
                                                                        <span className="minus" onClick={(event) => subtractValue(event)}>-</span>
                                                                        <input type="text" value={priceGet} className="set-stake-form-input" onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
        let old = priceGet
      setPriceGet(value);
      updateBook(e,old,value);
    }
  }}  aria-label="Last name"
                                                                            autoFocus="" maxLength="8" />
                                                                        <span className="plus" onClick={(event) => PlusValue(event)}>+</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="betslip-placebutton">
                                                                <div className="price-btns">
                                                                {/* {console.log(stack,"stackArraystackArraystackArray") } */}
                                                                {Array.isArray(stack) && stack.map((item,index) => (
                                                            <span key={index} id={`${item}`} onClick={(event) => addValue(`${item}`,event)}>{formatNumberinStack(item)}</span>
                                                        )) }
                                                                    <span id="1000" className="MAX" onClick={(event)=>addAllValue(`${convertToOriginalValue(receivedMatchodds?.finalResult?.[0]?.max_stake)}`,event)}>MAX</span>
                                                                    <span id="1000" className="MAX" onClick={(event)=>addAllValue(`${allValue()}`,event)}>All</span>
                                                                </div>
                                                                <div className="betplace-btn">
                                                                    {isLoggedIn || loggedIn ? <button className="place-bet" onClick={(event) =>{
                                                                        onBetClick({ eventid: eventAccess?.matchData?.eventId, marketId: eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId, stake: priceGet, bklyClassValue, selectionName: oddItem.runnerName, secId: oddItem.runnerId, oddsValue })
                                                                    } }>Place Bet</button> : <button onClick={openPopup} className="login-btn">Login to continue</button>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={`betslip_mobileview ${direactsecId === oddItem.runnerId ? 'active' : ''} ${bklyClassValue}`}>
                                                            <div className="close-btn" onClick={handlecloseSlip}>×</div>
                                                            <table className="eventdetails">
                                                                <tbody>
                                                                    <tr>
                                                                        <td>
                                                                            <div className='plus-minus-wraper'>
                                                                            <div className='plus-minus'>
                                                                                <span onClick={(event) => handleDecrementOdds(event)}>-</span>
                                                                                <input type="text" value={oddsValue} />
                                                                                <span onClick={(event) => handleIncrementOdds(event)}>+</span>
                                                                            </div>
                                                                            <div className='plus-minus'>
                                                                                <span onClick={(event) => subtractValue(event)}>-</span>
                                                                                <input type="text" value={priceGet} className="set-stake-form-input" onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
        let old = priceGet
        updateBook(e,old,value);
      setPriceGet(value);
    }
  }}  aria-label="Last name" autoFocus="" maxLength="8" inputMode="numeric" />
                                                                                <span onClick={(event) => PlusValue(event)} >+</span>
                                                                            </div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td colSpan="11" className='mbet-slip'>
                                                                            <div className="mbet-slip-wraper">
                                                                            {Array.isArray(stack) && stack.map((item,index) => (
                                                                                <div key={index} id={`${item}`} className="odds-value" onClick={(event) => addValue(`${item}`,event)}>{formatNumberinStack(item)}</div>
                                                                            )) }
                                                                                <div className="odds-value max" onClick={(event)=>addAllValue(`${convertToOriginalValue(receivedMatchodds?.finalResult?.[0]?.max_stake)}`,event)} id="10000">MAX</div>
                                                                                <div className="odds-value all" onClick={(event)=>addAllValue(`${allValue()}`,event)} id="98941.80">ALL IN</div>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="numbering">
                                                                        <td colSpan="11">
                                                                            <table>
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td><span onClick={(event) => incrementValue('1',event)} id="1">1</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('2',event)} id="2">2</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('3',event)} id="3">3</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('4',event)} id="4">4</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('5',event)} id="5">5</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('6',event)} id="6">6</span></td>
                                                                                        <td rowSpan="2"><span className="back-span" onClick={(event) => removeLastDigit(event)}><img alt="" src={betslipclosearrow} decoding="async" loading="lazy"/></span></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td><span onClick={(event) => incrementValue('7',event)} id="7">7</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('8',event)} id="8">8</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('9',event)} id="9">9</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('0',event)} id="0">0</span></td>
                                                                                        <td><span onClick={(event) => incrementValue('00',event)} id="double0">00</span></td>
                                                                                        {/* <td><span onClick={(event) => incrementValue('000',event)} id="dot">000</span></td> */}
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>
                                                                    <tr className="bet-btns">
                                                                        <td colSpan="11">
                                                                            <div className="btn-wraper">
                                                                                <button className="btn cancel-bet" onClick={handlecloseSlip}>CANCEL</button>
                                                                                {isLoggedIn || loggedIn ? <button className="btn place-bet" onClick={(event) => {
                                                                                    onBetClick({ eventid: eventAccess?.matchData?.eventId, marketId: eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId, stake: priceGet, bklyClassValue, selectionName: oddItem.runnerName, secId: oddItem.runnerId, oddsValue })
                                                                                }}>Place Bet</button> : <button onClick={openPopup} className="btn login-btn">Login to continue</button>}
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    {isBetLoader ?
                                                <div className="loader-sec loading">
                                                    Placing Your Bet, Please Wait <div className='loader-box'><span className='loading-number'>{String(loaderCounter).padStart(2, '0')}</span><span className='loader'></span></div>
                                                    </div> : ''}
                                                </div>
                                            </div>
                                        ))}
                                        {myNotification && myNotification.length > 0 && <SubNotification isFancy={false} msg={myNotification && myNotification.find(noti => noti.marketId == eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId) ? (myNotification.find(noti => noti.marketId == eval(`receivedunderOve${i}`)?.finalResult?.[0].marketId)?.notifications) : ''} />}
                                    </div>
                                </div>
                                </AccordionItem>
                        </Accordion>

                            </div>
                        </div>
                    ) : ''
                ))}

            <ExchanngeinfoPopup isOpen={grulesPopup} handleClose={gruleshandleClose} />
        </>
    )
}

export default MatchOdds